import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";

export default function Layout({ children, isAdmin, onLogout }) {

  // Scroll to Top Button Logic
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-dark text-white shadow-lg">
        <div className="container mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left: Logo + Title */}
          <div className="flex items-center text-center md:text-left">
            <img
              src="/snsulogo.png"
              alt="SNSU Logo"
              className="w-12 h-12 md:w-16 md:h-16 mr-3"
            />
            <div className="flex flex-col">
              <Link
                to="/"
                className="text-xl md:text-2xl font-extrabold tracking-tight text-white"> SNSU PALAKASAN 2025
              </Link>
               <div className="flex items-center text-xs md:text-sm mt-1">
                📍 Narciso St., 8400, Surigao City, SDN Campus
               </div>

            </div>
          </div>

          {/* Right: Menu */}
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-3">
            <ul className="flex flex-wrap justify-center gap-4 text-sm md:text-base">
              <li>
                <Link
                  to="/"
                  className="hover:underline font-medium flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#FFD700"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    className="mr-1"
                  >
                    <path d="M12 3l9 9-1.5 1.5L18 12.5V20h-5v-5H11v5H6v-7.5L4.5 13.5 3 12l9-9z" />
                  </svg>
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/editorial-staff"
                  className="hover:underline font-medium flex items-center"
                >
                  📝 Staff
                </Link>
              </li>

              <li>
                <Link
                  to="/announcements"
                  className="hover:underline font-medium flex items-center"
                >
                  📢 Announcements
                </Link>
              </li>

              {isAdmin && (
                <li>
                  <Link
                    to="/admin"
                    className="bg-yellow-500 text-black px-3 py-1 rounded hover:bg-yellow-400 font-medium"
                  >
                    Admin
                  </Link>
                </li>
              )}
            </ul>

            {/* Logout / Login */}
            {isAdmin ? (
              <button
                onClick={onLogout}
                className="btn btn-secondary px-3 py-1 text-sm"
              >
                Logout
              </button>
            ) : (
              <Link
                to="/admin"
                className="bg-yellow-500 text-black px-3 py-1 rounded hover:bg-yellow-400 font-medium text-sm"
              >
                Admin Login
              </Link>
            )}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 py-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-dark text-white py-6 text-sm">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6">
          
          {/* Left Section */}
          <div className="flex items-center space-x-2">
            <img
              src="/snsulogo.png"
              alt="School Logo"
              className="w-10 h-10 md:w-12 md:h-12"
            />
            <span className="text-center md:text-left">
              © 2025 Surigao del Norte State University
            </span>
          </div>

          {/* Center Section */}
          <div className="text-center md:text-center">
            <p className="text-lg font-bold text-yellow-400">
              "𝔉𝔦𝔞𝔱 𝔩𝔲𝔵, 𝔣𝔦𝔞𝔱 𝔳𝔢𝔯𝔦𝔱𝔞𝔰"
            </p>
            <p className="text-sm">"Let there be light, let there be truth."</p>
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-2">
            <img
              src="/hub.png"
              alt="Developer Profile"
              className="w-10 h-10 rounded-full"
            />
            <div className="text-center md:text-left">
              <span className="text-yellow-400">We Deliver Excellence</span>
              <br />
              <span className="text-sm">The Hub</span>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-yellow-500 text-black p-3 rounded-full shadow-lg hover:bg-yellow-400 transition duration-300"
        >
          ↑
        </button>
      )}
    </div>
  );
}
